const textChange = () => {
    const texts = document.querySelectorAll('.js-text-change>*');
    texts.forEach((item) => {
        item.closest('.js-text-change')?.removeAttribute('style');
    });
    texts.forEach((item) => {
        const className = item.getAttribute('class');
        const style = item.closest('.js-text-change')?.getAttribute('style')
            ? item.closest('.js-text-change')?.getAttribute('style')
            : '';
        item
            .closest('.js-text-change')
            ?.setAttribute(
                'style',
                style + '--' + className + ':' + item.scrollHeight + 'px;',
            );
    });
};

document.addEventListener('DOMContentLoaded', () => {
    textChange();
});

window.addEventListener('resize', () => {
    textChange();
});
